import { ProjectDetailsLayout } from "@/routes/projects/details/ProjectDetailsLayout";
import { ProjectSettingsPage } from "@/routes/projects/details/ProjectSettingsPage";
import { ProjectSecretsPage } from "@/routes/projects/details/ProjectSecretsPage";
import { ProjectPrebuildsPage } from "@/routes/projects/details/ProjectPrebuildsPage";
import { ProjectsPage } from "@/routes/projects/ProjectsPage";
import { ProjectsPagePaginated } from "@/routes/projects/ProjectsPagePaginated";
import { PageSuspense } from "@/components/PageSuspense";
import { useFlag } from "@/hooks/use-flag";
import { Flags } from "@/feature-flags";
import { Navigate, Outlet, type RouteObject } from "react-router-dom";

export const ProjectsRoute = () => {
    const { value: paginatedEnabled } = useFlag(Flags.PaginatedProjectsList, false);
    return paginatedEnabled ? <ProjectsPagePaginated /> : <ProjectsPage />;
};

// eslint-disable-next-line react-refresh/only-export-components
export const projectDetailsRoutes: RouteObject = {
    path: ":projectId",
    element: <ProjectDetailsLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="settings" replace />,
        },
        {
            path: "settings",
            element: <ProjectSettingsPage />,
            handle: {
                menuItem: {
                    label: "Settings",
                    to: "settings",
                    section: "project",
                },
            },
        },
        {
            path: "secrets",
            element: <ProjectSecretsPage />,
            handle: {
                menuItem: {
                    label: "Secrets",
                    to: "secrets",
                    section: "project",
                },
            },
        },
        {
            path: "prebuilds",
            element: <ProjectPrebuildsPage />,
            handle: {
                menuItem: {
                    label: "Prebuilds",
                    to: "prebuilds",
                    section: "project",
                },
            },
        },
    ],
};

// eslint-disable-next-line react-refresh/only-export-components
export const projectRoutes: RouteObject = {
    path: "projects",
    handle: {
        label: "Projects",
    },
    element: (
        <PageSuspense>
            <Outlet />
        </PageSuspense>
    ),
    children: [
        {
            index: true,
            element: <ProjectsRoute />,
        },
        projectDetailsRoutes,
    ],
};
